import { makeCommonStore, FormField } from '../commons'
import TransactionService from '@/services/TransactionService'

const store = {
  ...makeCommonStore(
    {
      service: TransactionService,
      fields: [
        new FormField({
          name: 'id',
          hidden: true
        }),
        new FormField({
          name: 'description',
          label: 'Description',
          icon: 'description',
          rules: ['required'],
          md: 12
        }),
        new FormField({
          name: 'category',
          type: 'select',
          label: 'Category',
          icon: 'category',
          items: [],
          rules: ['required'],
          md: 12
        }),
        new FormField({
          name: 'bank_account',
          type: 'select',
          label: 'Bank Account',
          items: [],
          rules: ['required'],
          md: 12
        }),
        new FormField({
          name: 'transtime',
          type: 'date',
          label: 'Date',
          rules: ['required'],
          md: 6
        }),
        new FormField({
          name: 'gst_included',
          type: 'checkbox',
          label: 'GST included',
          md: 6
        }),
        new FormField({
          name: 'trans_type',
          type: 'select',
          label: 'Deposit or withdrawal',
          icon: 'category',
          items: [
            { text: 'Deposit', value: 'D' },
            { text: 'Withdrawal', value: 'W' }
          ],
          md: 6
        }),
        new FormField({
          name: 'amount',
          label: 'Amount',
          rules: ['required', 'amount'],
          md: 6
        }),
        new FormField({
          name: 'trans_source',
          hidden: true
        }),
        new FormField({
          name: 'trans_hash',
          hidden: true
        })
      ]
    },
    ['fields']
  ),
  namespaced: true
}

store.getters = {
  ...store.getters,

  category (state) {
    return state._data.fields[2].value
  }
}

store.mutations = {
  ...store.mutations,

  updateCategoryOptions (state, options) {
    state._data.fields[2].items = options
  },

  updateAccountOptions (state, options) {
    state._data.fields[3].items = options
  },

  updateGstIncluded (state, val) {
    state._data.fields[5].value = val
  },

  updateEnableGstIncluded (state, val) {
    state._data.fields[5].disabled = !val
  }
}

store.actions = {
  ...store.actions,

  enableGstIncluded ({ commit, state }, data) {
    commit('updateEnableGstIncluded', data)
  },

  setCategoryOptions ({ commit, state }, data) {
    commit('updateCategoryOptions', data)
  },

  setAccountOptions ({ commit, state }, data) {
    commit('updateAccountOptions', data)
  },

  setGstIncluded ({ commit, state }, data) {
    commit('updateGstIncluded', data)
  },

  getGstRegistered ({ commit, state }, category) {
    return state._data.fields[2].items.filter(item => item.value === category).gst_registered
  }
}

export default store
